



















































































































































































































































































































































































































































































































import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';
import Booking from '@/models/Booking';
import formatCustomer from '@/utils/formatCustomer';
// @ts-ignore
import localeDatePicker from 'ant-design-vue/lib/date-picker/locale/fr_FR';
import UploadComponent, {
    InputFile,
} from '@/components/common/UploadComponent.vue';
import {
    postBookingDocumentAdmin,
    deleteBookingDocumentAdmin,
    postBookingContractReceived,
    patchBooking,
    patchBookingRegistration,
    postBookingGoToFunding,
    postBookingPropertyAttestationReceived,
    postBookingInvoiceDocumentReceived,
    sendBookingSms,
} from '@/api/api';
import get from 'lodash/get';
import moment from 'moment';
import PatchBookingRegistrationRequest from '@/models/PatchBookingRegistrationRequest';
import {
    bookingProgression,
    formatBookingProgression,
} from '@/data/bookingProgression';
import { bookingDocumentsTypes } from '@/data/bookingDocumentsTypes';

class RecordingForm {
    notaryBuyer = {
        type: 'notary',
        study_name: '',
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
    };
    notaryPromoter = {
        type: 'notary',
        study_name: '',
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
    };
    dateSignatureAppointment: moment.Moment | null = null;
    actSignedAt: moment.Moment | null = null;
    loanRequestDeadline: moment.Moment | null = null;
    loanReceptionDeadline: moment.Moment | null = null;
    // date_sale_act: moment.Moment | null = null;
    amountDg: number | undefined = undefined;

    get notaryBuyerValid() {
        return (
            this.notaryBuyer.type &&
            this.notaryBuyer.study_name &&
            this.notaryBuyer.lastname &&
            this.notaryBuyer.firstname &&
            this.notaryBuyer.email &&
            this.notaryBuyer.phone
        );
    }

    get notaryPromoterValid() {
        return (
            this.notaryPromoter.type &&
            this.notaryPromoter.study_name &&
            this.notaryPromoter.lastname &&
            this.notaryPromoter.firstname &&
            this.notaryPromoter.email &&
            this.notaryPromoter.phone
        );
    }

    get datesValid() {
        return (
            this.actSignedAt &&
            this.loanRequestDeadline &&
            this.loanReceptionDeadline &&
            // this.date_sale_act &&
            this.dateSignatureAppointment
        );
    }

    get valid() {
        return (
            this.notaryBuyerValid && this.notaryPromoterValid && this.datesValid
        );
    }

    toRequestOrNull(): PatchBookingRegistrationRequest | null {
      console.log(this.notaryBuyer)
      console.log(this.notaryPromoter)
        if (
            !this.valid ||
            !this.actSignedAt ||
            !this.loanRequestDeadline ||
            !this.loanReceptionDeadline ||
            // !this.date_sale_act ||
            !this.dateSignatureAppointment
        ) {
            return null;
        }

        return {
            notaryBuyer: {
                ...this.notaryBuyer,
            },
            notaryPromoter: {
                ...this.notaryPromoter,
            },
            actSignedAt: this.actSignedAt.toDate(),
            loanRequestDeadline: this.loanRequestDeadline.toDate(),
            loanReceptionDeadline: this.loanReceptionDeadline.toDate(),
            // date_sale_act: this.date_sale_act.toDate(),
            dateSignatureAppointment: this.dateSignatureAppointment.toDate(),
            amountDg: this.amountDg,
        };
    }
}

interface Loaders {
    [index: string]: boolean;
}

interface Files {
    [index: string]: InputFile | null;
}

@Component({
    components: {
        UploadComponent,
    },
    filters: {
        formatCustomer,
        formatBookingProgression,
        formatDate(date: string) {
            return moment(date).format('LL');
        },
        formatHour(date: string) {
            return moment(date).format('LT');
        },
    },
    methods: {
        get,
    },
})
export default class BookingFormAdmin extends Vue {
    @Model('booking') readonly booking!: Booking | undefined;
    guarantee: string = 'no';
    type: string = '';
    deleteComment: string = '';
    showConfirmationDelete: Boolean = false;
    errors: any = null;
    same: string = 'no';
    cash_payment: string = '';

    progression: object = {
        'to_deal':'signature',
        'signature':'recording',
        'recording':'funding',
        'funding':'actable',
        'actable':'acted',
        'acted':'commissioned'
    }

    mounted() {
        if (!this.booking) {
            return;
        }
        if (this.booking.cash_payment) {
            this.cash_payment = 'yes';
        } else {
          this.cash_payment = 'no';
        }
        if (this.booking.booking_form) {
            this.files.bookingForm = {
                filename: `${this.booking.booking_form.name}.${this.booking.booking_form.extension}`,
                data: '',
            }
        }

        if (this.booking.dg_attestation) {
          this.files.dgAttestation = {
            filename: `${this.booking.dg_attestation.name}.${this.booking.dg_attestation.extension}`,
            data: '',
          }
        }

        if (this.booking.promoter_direct_invoice) {
          this.files.promoterDirectInvoice = {
            filename: `${this.booking.promoter_direct_invoice.name}.${this.booking.promoter_direct_invoice.extension}`,
            data: '',
          }
        }

      if (this.booking.invoice_document) {
        this.files.invoiceDocument = {
          filename: `${this.booking.invoice_document.name}.${this.booking.invoice_document.extension}`,
          data: '',
        }
      }

        if (this.booking.contract_counter_signed) {
          this.files.contractCounterSigned = {
            filename: `${this.booking.contract_counter_signed.name}.${this.booking.contract_counter_signed.extension}`,
            data: '',
          }
        }

        if (this.booking.contract) {
            this.files.contract = {
                filename: `${this.booking.contract.name}.${this.booking.contract.extension}`,
                data: '',
            };
        }

        if (this.booking.contract_signed) {
            this.files.contractSigned = {
                filename: `${this.booking.contract_signed.name}.${this.booking.contract_signed.extension}`,
                data: '',
            };
        }

        if (this.booking.loan_resquest_attestation) {
            this.files.loanResquestAttestation = {
                filename: `${this.booking.loan_resquest_attestation.name}.${this.booking.loan_resquest_attestation.extension}`,
                data: '',
            };
        }

        if (this.booking.financing_agreement) {
            this.files.financingAgreement = {
                filename: `${this.booking.financing_agreement.name}.${this.booking.financing_agreement.extension}`,
                data: '',
            };
        }

        if (this.booking.loan_offer_signed) {
            this.files.loanOfferSigned = {
                filename: `${this.booking.loan_offer_signed.name}.${this.booking.loan_offer_signed.extension}`,
                data: '',
            };
        }

        if (this.booking.property_attestation) {
            this.files.propertyAttestation = {
                filename: `${this.booking.property_attestation.name}.${this.booking.property_attestation.extension}`,
                data: '',
            };
        }

        if (this.booking.transfer_proof) {
            this.files.transferProof = {
                filename: `${this.booking.transfer_proof.name}.${this.booking.transfer_proof.extension}`,
                data: '',
            };
        }

        if (this.booking.notary_buyer) {
            this.recordingForm.notaryBuyer = {
                ...this.recordingForm.notaryBuyer,
                ...this.booking.notary_buyer,
            };
        }

        if (this.booking.notary_promoter) {
            this.recordingForm.notaryPromoter = {
                ...this.recordingForm.notaryPromoter,
                ...this.booking.notary_promoter,
            };
        }

        if (this.booking.act_signed_at) {
            this.recordingForm.actSignedAt = moment(this.booking.act_signed_at);
        }

        if (this.booking.loan_request_deadline) {
            this.recordingForm.loanRequestDeadline = moment(
                this.booking.loan_request_deadline
            );
        }

        if (this.booking.loan_reception_deadline) {
            this.recordingForm.loanReceptionDeadline = moment(
                this.booking.loan_reception_deadline
            );
        }

        // if (this.booking.date_sale_act) {
        //     this.recordingForm.date_sale_act = moment(
        //         this.booking.date_sale_act
        //     );
        // }

        if (this.booking.date_signature_appointment) {
          this.recordingForm.dateSignatureAppointment = moment(
              this.booking.date_signature_appointment
          );

          this.recordingForm.loanRequestDeadline = moment(this.recordingForm.dateSignatureAppointment).add(30, 'days');
          this.recordingForm.actSignedAt = moment(this.recordingForm.dateSignatureAppointment).add(60, 'days');
          this.recordingForm.loanReceptionDeadline = moment(this.recordingForm.dateSignatureAppointment).add(75, 'days');
        }

        if(this.booking.amount_dg) {
          this.recordingForm.amountDg = this.booking.amount_dg
        }
    }

    localeDatePicker = localeDatePicker;

    recordingForm = new RecordingForm();

    loaders: Loaders = {
        loadingContract: false,
        loadingContractSigned: false,
        loadingLoanResquestAttestation: false,
        loadingFinancingAgreement: false,
        loadingLoanOfferSigned: false,
        propertyAttestation: false,
        transferProof: false,
        bookingForm: false,
        promoterDirectInvoice: false,
        invoiceDocument: false,
    };

    files: Files = {
        promoterDirectInvoice: null,
        contract: null,
        contractSigned: null,
        loanResquestAttestation: null,
        financingAgreement: null,
        loanOfferSigned: null,
        propertyAttestation: null,
        transferProof: null,
        bookingForm: null,
        dgAttestation: null,
        invoiceDocument: null,
    };

    async log() {
      let dateSign: moment.Moment | null = this.recordingForm.dateSignatureAppointment;
      if(this.recordingForm.dateSignatureAppointment !== null) {
        this.recordingForm.actSignedAt = moment(this.recordingForm.dateSignatureAppointment).add(60, 'days');
        this.recordingForm.loanRequestDeadline = moment(this.recordingForm.dateSignatureAppointment).add(30, 'days');
        this.recordingForm.loanReceptionDeadline = moment(this.recordingForm.dateSignatureAppointment).add(75, 'days');
        //this.recordingForm.date_sale_act = moment(this.recordingForm.dateSignatureAppointment).add(90, 'days');
      }
    }

    async commentVerif() {
      if(this.deleteComment == '') {
        return true;
      } else {
        return false;
      }
    }

    async onFile(file: InputFile, type: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        try {
            this.loaders[type] = true;
            const { data } = await postBookingDocumentAdmin(
                this.booking.id,
                type,
                {
                    file_name: file.filename,
                    document: file.data,
                }
            );

            this.$emit('booking', data);
            this.showSuccess('Fichier ajouté');
        } catch (e) {
            this.files[type] = null;
            this.showError(e, `Erreur lors de l'envoi`);
        } finally {
            this.loaders[type] = false;
        }
    }

    async onDelete(type: string) {
        this.type = type;
        this.showConfirmationDelete = true;
    }

    deleteFile(){
      if (!this.booking || !this.booking.id) {
        return;
      }

      let comment = encodeURIComponent(this.deleteComment);

      deleteBookingDocumentAdmin(this.booking.id, this.type, '(' + comment + ')')
          .then(() => {
            this.showSuccess('Document supprimé');
            this.files[this.type] = null;
          })
          .catch(e => {
            this.showError(e, 'Erreur lors de la supression du document');
          });

      this.deleteComment = '';
      this.showConfirmationDelete = false;
    }

    async sendSms() {
        const $vs = (this as any).$vs;
        if(this.booking) {
            try {
                const {data} = await sendBookingSms(this.booking);
                return $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: "Succès",
                    text: "SMS Envoyé",
                });
            } catch (error) {
                return $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: "Erreur",
                    text: "Impossible d'envoyer le sms vérifiez les infos de ce prescripteur",
                });
            }
        }
    }

    async validate(doc: string) {
      if (!this.booking || !this.booking.id) {
        return;
      }

      let patch: Booking = {};
      if(doc == 'dg_attestation_is_valid') {
        patch = {dg_attestation_is_valid:true};
      } else if (doc == 'loan_request_attestation_is_valid') {
        patch = {loan_request_attestation_is_valid:true};
      } else if (doc == 'financing_agreement_is_valid') {
        patch = {financing_agreement_is_valid:true};
      } else if (doc == 'loan_offer_signed_is_valid') {
        patch = {loan_offer_signed_is_valid:true};
      } else if (doc == 'invoice_document_is_valid') {
        patch = {invoice_document_is_valid:true};
      } else if (doc == 'property_attestation_is_valid') {
        patch = {property_attestation_is_valid:true};
      }

      if(patch !== {}) {
        try {
          const { data } = await patchBooking(this.booking.id,
              patch
          );

          this.showSuccess("Document validé")
          this.$emit('booking', data);
        } catch (e) {
          this.showError(e, "Erreur lors de la validation du document..")
        }
      }
    }

    async validateProgression(nextProgression: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        const { data } = await patchBooking(this.booking.id, {
            progression: nextProgression,
        });

        this.$emit('booking', data);
    }
    async fillSecondForm() {
      const $vs = (this as any).$vs;
      if(this.same == 'yes') {
        this.recordingForm.notaryPromoter.type = 'notary';
        this.recordingForm.notaryPromoter = this.recordingForm.notaryBuyer;

        return $vs.notify({
          color: 'success',
          position: 'top-right',
          title: "Succès",
          text: 'Le notaire prescripteur est maintenant le même que le notaire acquéreur',
        });
      }else{
        this.recordingForm.notaryPromoter = {
          type: 'notary',
          study_name: '',
          lastname: '',
          firstname: '',
          email: '',
          phone: '',
        }
      }
    }

    async setCashPayment() {
        if (!this.booking || !this.booking.id) {
            return;
        }

        let value = false;
        if(this.cash_payment == 'yes') {
          value = true
        }

        const { data } = await patchBooking(this.booking.id, {
            cash_payment: value,
        });

        const $vs = (this as any).$vs;

        let text = '';
        if(value) {
          text = 'Le client paiera comptant'
        } else {
          text = 'Le client ne paiera pas comptant';
        }
        $vs.notify({
          color: 'success',
          position: 'top-right',
          title: 'Succès',
          text: text,
        });

        this.$emit('booking', data);
    }

    async onContractReceived() {
        if (!this.booking || !this.booking.id) {
            return;
        }

        const { data } = await postBookingContractReceived(this.booking.id);
        this.$emit('booking', data);
    }

    async validateRecording() {
        if (!this.booking || !this.booking.id) {
            return;
        }

        const req = this.recordingForm.toRequestOrNull();
        if (!req) {
            return;
        }

        try {
            await patchBookingRegistration(this.booking.id, req);
            // on passe la résa en status funding après le post
            if (!this.booking.cash_payment) {
                const { data } = await postBookingGoToFunding(this.booking.id);
                this.$emit('booking', data);
            } else if (this.booking.cash_payment) {
                const { data } = await patchBooking(this.booking.id, {
                    progression: 'actable',
                });
                this.$emit('booking', data);
            }
        } catch (error) {
            const $vs = (this as any).$vs;

            this.errors = get(error, 'response.data.errors.children', null);

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `Erreur lors de la soumission du formulaire`,
            });
        }
    }

    async nextStep(progression: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        let progress: string = await this.nextProgression(progression)

        const { data } = await patchBooking(this.booking.id, {
            progression: progress,
        });

        this.$emit('booking', data);
    }

    async previousStep(progression: string) {
        if (!this.booking || !this.booking.id) {
            return;
        }

        let progress: string = await this.previousProgression(progression)

        const { data } = await patchBooking(this.booking.id, {
            progression: progress,
        });

        this.$emit('booking', data);
    }

    nextProgression(actual: string): string {
        return get(this.progression, actual, actual);
    }

    previousProgression(actual: string): string {
        return get(this.invert(this.progression), actual, actual);
    }

    invert(object: Object) {
        let ret: Object = {};
        for (const key in object) {
            //@ts-ignore
            ret[object[key]] = key;
        }
        return ret;
    }



    async validateActable() {
        if (!this.booking || !this.booking.id) {
            return;
        }

        const { data } = await postBookingPropertyAttestationReceived(
            this.booking.id
        );

        this.$emit('booking', data);
    }

    async validateActed() {
        if (!this.booking || !this.booking.id) {
            return;
        }

        const { data } = await postBookingInvoiceDocumentReceived(
            this.booking.id
        );

        this.$emit('booking', data);
    }

    showSuccess(message: string) {
        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Succès',
            text: message,
        });
    }

    showError(error: Error, defaultMessage: string) {
        const message = get(error, 'response.data.message', defaultMessage);

        const $vs = (this as any).$vs;
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: message,
        });
    }

    disabledDate(current: moment.Moment) {
        return current && current < moment().startOf('day');
    }

    disabledSignDate(current: moment.Moment) {
      return current && current >= moment().startOf('day');
    }

    get isDatesValid() {
        if (
            this.recordingForm.loanRequestDeadline &&
            this.recordingForm.actSignedAt &&
            this.recordingForm.loanReceptionDeadline
            // this.recordingForm.date_sale_act
        ) {
            // isBefore faisant un check <=, on ajoute un jour pour forcer à <
            return (
                this.recordingForm.loanRequestDeadline
                    .clone()
                    .add(1, 'days')
                    .isBefore(this.recordingForm.actSignedAt) &&
                this.recordingForm.actSignedAt
                    .clone()
                    .add(1, 'days')
                    .isBefore(this.recordingForm.loanReceptionDeadline)
            );
        }

        // Si il manque une date on ne fait pas le check
        return true;
    }
}
